export const draggableAnswerStyle =
  'cursor-grab rounded-full border border-brand bg-brand-50 px-2 text-lg leading-6 select-none'
